module.exports = __webpack_public_path__ + "static/media/Arduino_Logo.3c4a7e1e.svg";